import styled from "react-emotion";
export const ContentWrapper = styled("div")({
  flex: "1 0 auto"
});
